export default {
    loaded: "modules.loaded",
    module_modals: {
        show: "modules.module_modals.show",
        close: "modules.module_modals.close",
        update: "modules.module_modals.update"
    },
    modals: {
        show: "modules.modals.show",
        close: "modules.modals.close",
        update: "modules.modals.update"
    }
}